import { Divider } from "antd";

const Kedrab = () => {
  return (
    <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
      <Divider />
      <p className="m-2 font-bold">
        INDICATIONS AND USAGE
      </p>

      <p className="m-2">
        KEDRAB is a human rabies immune globulin (HRIG) indicated for passive, transient post-exposure prophylaxis (PEP)
        of rabies infection to persons of all ages when given immediately after contact with a rabid or possibly rabid
        animal. KEDRAB should be administered concurrently with a full course of rabies vaccine.
      </p>

      <p className="m-2 font-bold">
        IMPORTANT SAFETY INFORMATION
      </p>

      <p className="m-2">
        <b>CONTRAINDICATIONS: </b>None.
      </p>

      <p className="m-2 font-bold">
        WARNINGS AND PRECAUTIONS:
      </p>

      <p className="m-2">
        Patients who can document previous complete rabies pre-exposure prophylaxis or complete post-exposure
        prophylaxis should only receive a booster rabies vaccine without KEDRAB because KEDRAB may interfere with the
        anamnestic response to the rabies vaccine.
      </p>

      <p className="m-2 font-bold">
        HYPERSENSITIVITY REACTIONS:
      </p>

      <p className="m-2">
        Hypersensitivity reactions, including anaphylaxis, may occur with KEDRAB. IgA deficient patients with antibodies
        against IgA are at greater risk. Have epinephrine available immediately to treat any acute severe
        hypersensitivity reactions.
      </p>

      <p className="m-2 font-bold">
        LIVE ATTENUATED VIRUS VACCINES:
      </p>

      <p className="m-2">
        KEDRAB administration may interfere with the development of an immune response to live attenuated virus
        vaccines. If feasible, delay immunization with measles vaccine for 4 months, and other live attenuated virus
        vaccines for 3 months, after KEDRAB administration.
      </p>

      <p className="m-2 font-bold">
        INTERFERENCE WITH SEROLOGICAL TESTING:
      </p>

      <p className="m-2">
        A transient rise of the various passively transferred antibodies in the patient’s blood may result in misleading
        positive results of serologic tests after KEDRAB administration.
      </p>

      <p className="m-2">
        Passive transmission of antibodies to erythrocyte antigens, e.g., A, B, and D, may interfere with serologic
        tests for red cell antibodies such as the antiglobulin test (Coombs’ test).
      </p>

      <p className="m-2 font-bold">
        TRANSMISSIBLE INFECTIOUS AGENTS:
      </p>

      <p className="m-2">
        Because KEDRAB is made from human plasma donors hyper-immunized with rabies vaccine, it may carry a risk of
        transmitting infectious agents, e.g., viruses, the variant Creutzfeldt-Jakob disease (vCJD) agent and,
        theoretically, the Creutzfeldt-Jakob disease (CJD) agent. All infections suspected by a physician possibly to
        have been transmitted by this product should be reported by the physician or other healthcare provider to
        Kedrion Biopharma Inc. at 1-855-353-7466.
      </p>

      <p className="m-2 font-bold">
        ADVERSE REACTIONS:
      </p>

      <p className="m-2">
        The most common adverse reactions in adult subjects treated with KEDRAB in clinical trials were injection site
        pain, headache, muscle pain, joint pain, dizziness, and fatigue.
      </p>

      <p className="m-2">
        In pediatric subjects treated with KEDRAB and a full course of rabies vaccine, the most common adverse reactions
        were injection site pain, headache, fever, pain in extremity, bruising (hematoma), fatigue, and vomiting.
      </p>

      <p className="m-2">
        Less common adverse reactions (≤5%) in pediatric patients were injection site redness (erythema), injection site
        swelling (edema), muscle pain, oral pain, and wound complication. Insomnia was reported as a less common adverse
        reaction (&lg;5%) in pediatric patients occurring after 14 days of administration.
      </p>

      <p className="m-2 font-bold">
        DRUG INTERACTIONS:
      </p>

      <p className="m-2">
        Patients who can document previous complete rabies pre-exposure prophylaxis or complete post-exposure
        prophylaxis and have a confirmed adequate rabies antibody titer should receive only a booster rabies vaccine
        (without KEDRAB) because KEDRAB may interfere with the anamnestic response to the vaccine (ACIP).
      </p>

      <p className="m-2">
        KEDRAB can interfere with the immune response to the rabies vaccine. For this reason, do not exceed the recommended KEDRAB dose or give additional (repeat) doses of KEDRAB once rabies vaccination has been initiated.
      </p>

      <p className="m-2">
        KEDRAB can inactivate the rabies vaccine. For this reason, do not administer KEDRAB in the same syringe as the rabies vaccine or near the anatomical site of administration of the rabies vaccine.
      </p>

      <div>
        <p className="m-2">
          <b>
            Please see&nbsp;
            <a
              target="_blank"
              href="/KEDRAB-prescribing-information.pdf"
              className="text-blue-500 hover:underline"
            >
              Full Prescribing Information
            </a>
            &nbsp;for complete prescribing details.
          </b>
        </p>
        <p className="m-2">
          <b>
            To report SUSPECTED ADVERSE REACTIONS, contact Kedrion Biopharma Inc. at 1-855-353-7466 or the FDA at 1-800-FDA-1088 or&nbsp;
            <a
              target="_blank"
              href="http://www.fda.gov/medwatch"
              className="text-blue-500 hover:underline"
            >
              www.fda.gov/medwatch
            </a>
            &nbsp;or call 1-800-FDA-1088.
          </b>
        </p>
      </div>
    </div>
  )
}

export default Kedrab